import type { NavigationGuardReturn, RouteLocationNormalized } from 'vue-router';

import { useAuthStore } from '@/entities/auth';
import { useToast } from '@/shared/lib/toast';

/**
 * Guard для проверки прав доступа
 * Проверяет meta.permissions (необязательный параметр)
 */
export const permissionGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized): NavigationGuardReturn => {
  const permissions = to.meta.permissions;

  if (!permissions || permissions.length === 0) {
    return true;
  }

  const authStore = useAuthStore();
  const hasPermission = authStore.hasAnyPermission(permissions);

  if (!hasPermission) {
    const toast = useToast();
    toast.error('Недостаточно прав для просмотра этой страницы');

    if (from.name) {
      return { name: from.name, params: from.params, query: from.query };
    }
    return { name: 'home.index' };
  }

  return true;
};
